import React from "react";
import { formatNumber } from "src/common";
import { Text } from 'src/components';
import { colors } from "src/theme";
import { Card } from "./card";

export interface ImportantInfoCardProps {
  price: number;
}

export const ImportantInfoCard = ({ price }: ImportantInfoCardProps) => (
  <Card background={colors.background6} radius={8} padding={16}>
    <Text type='medium' bold color={colors.text2}>{`${formatNumber(price)} €/mjesečno`}</Text>
  </Card>
);

